type NotificationType = 'error' | 'success'

function getIconSVG(type: NotificationType): string {
	if (type === 'success') {
		return `<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			stroke="currentColor"
			stroke-width="1.5"
			viewBox="0 0 24 24"
			aria-hidden="true"
			class="svg-component SVGCircleCheck ca-alert__icon"
			data-test-component="design-system-icon-component"
			id=""
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
			></path>
		</svg>`
	}

	return `<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		stroke="currentColor"
		stroke-width="1.5"
		viewBox="0 0 24 24"
		aria-hidden="true"
		class="svg-component SVGCircleX ca-alert__icon"
		data-test-component="design-system-icon-component"
		id=""
	>
		<path
			stroke-linecap="round"
			stroke-linejoin="round"
			d="m10 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m7-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
		></path>
	</svg>`
}

export function createNotificationHTML(message: string, type: NotificationType = 'success'): string {
	return `<div class="ca-notification ca-notification__${type}" data-test="ca-notification-${type}" role="dialog">
		<div class="ca-notification-wrapper">
			<div class="ca-alert__icon-wrapper">${getIconSVG(type)}</div>

			<div class="ca-notification__message-wrapper">
				<p class="ca-notification__message" data-test="ca-notification-message">${message}</p>
			</div>
		</div>
	</div>`
}

export function showNotification(message: string, type: NotificationType = 'success'): void {
	const notificationHTML = createNotificationHTML(message, type)

	document.body.insertAdjacentHTML('beforeend', notificationHTML)
}
